<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="5">
        <el-input v-model="params.org_name" prefix-icon="el-icon-search" placeholder="输入供应商名称查询" clearable @change="onSearch()" />
      </el-col>

      <el-col :span="5" class="col_pos_right" align="right">
        <el-button v-permission="'增加供应商'" icon="el-icon-plus" @click="addUser()">添加供应商</el-button>
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed">
          <template slot-scope="scope">
            <span>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            <el-link v-for="item in $operationsFilter(operations)" :key="item.key" :type="item.type" @click="handleClick(item.key, scope.row)">{{ item.title }}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange">
    </el-pagination>

    <el-dialog width="600px" :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="componet_select = ''">
      <component :is="componet_select" :rowData="rowData" @tableCloseDialog="dialogVisible = false" />
    </el-dialog>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import supplierAdd from './add'
import supplierEdit from './edit'

export default {
  data () {
    return Backend.initListPage(this, 'org_provider', {
      route_name: '供应商管理列表',
      id_name: 'org_id',
      tableColList: [
        {
          key: 'org_id',
          name: '供应商ID',
          fixed: true
        },
        {
          key: 'org_name',
          name: '供应商名称'
        },
        {
          key: 'org_contact_name',
          name: '联系人'
        },
        {
          key: 'org_contact_phone',
          name: '联系电话'
        },
        {
          key: 'org_contact_mail',
          name: '供应商邮箱'
        }
      ],
      params: {
        org_name: ''
      },
      operations: [
        {
          key: 'edit',
          title: '编辑',
          icon: 'icon-bianji icon_1',
          type: 'primary',
          permiss: '编辑供应商'
        },
        {
          key: 'delete',
          title: '删除',
          icon: 'icon-shanchu icon_6',
          type: 'danger',
          permiss: '删除供应商'
        }
      ],
      dialogVisible: false,
      title: '添加供应商',
      componet_select: '',
      rowData: {}
    })
  },
  components: {
    'supplier-add': supplierAdd,
    'supplier-edit': supplierEdit
  },
  methods: {
    addUser () {
      this.title = '添加供应商'
      this.dialogVisible = true
      this.componet_select = 'supplier-add'
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    },
    handleClick (key, row) {
      if (key === 'edit') this.editRow(row)
      if (key === 'delete') this.deleteRow(row)
    },
    editRow (row) {
      this.title = '编辑供应商'
      this.dialogVisible = true
      this.componet_select = 'supplier-edit'
      this.rowData = row
    },
    deleteRow (row) {
      Backend.deleteRow(this, row, '供应商管理')
    }
  }
}
</script>
